import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import IMetaDataDto from '@core/mappers/offer/dtos/IMetaDataDto';
import { MetaData, BookingStatus, Time } from '@core/models/offer/MetaData';
import PeriodMapper from '@core/mappers/offer/PeriodMapper';

const periodMapper: PeriodMapper = new PeriodMapper();

export default class MetaDataMapper extends AbstractMapper<IMetaDataDto, MetaData> {

    createTargetObject(dto: IMetaDataDto, key?: string): MetaData {
        const metaData: Partial<MetaData> = {};
        metaData.team1Score = dto.t1Scr;
        metaData.team2Score = dto.t2Scr;
        metaData.minute = dto.min;
        metaData.periodStatus = dto.periodStatus || '';
        metaData.periods = periodMapper.map(dto.periods, true);
        metaData.bookingStatus = (dto.bookingStatus as BookingStatus) || '';
        metaData.team1GemScore = dto.t1GemScr;
        metaData.team2GemScore = dto.t2GemScr;
        metaData.serve = dto.tServ;
        if (dto.stoppageTime) {
            metaData.stoppageTime = this.parseTimeString(dto.stoppageTime);
            // there is also stoppageTimeAnnounced but we don't use it
        }
        metaData.t1YCrd = metaData.t1YCrd;
        metaData.t2YCrd = metaData.t2YCrd;
        metaData.t1RCrd = metaData.t1RCrd;
        metaData.t2RCrd = metaData.t2RCrd;
        metaData.t1Crn = metaData.t1Crn;
        metaData.t2Crn = metaData.t2Crn;
        return metaData as MetaData;
    }

    // time is on format mm:ss
    private parseTimeString(time: string): Time {
        const [minutes, seconds] = time.split(':').map(x => parseInt(x, 10));
        return {
            minutes,
            seconds,
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/offer/MetaDataMapper.ts